module.exports = __webpack_public_path__ + "img/sl.113a171b.png";